var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.573,
    height: 34.693,
    viewBox: "0 0 53.573 34.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44413",
    "data-name": "Group 44413",
    transform: "translate(-6396.71 4571.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26707",
    "data-name": "Path 26707",
    d: "M51.721,493.367c-2.366-.037-2.776,0-4.108,0H36.661v-11.4l5.806.677c1.062,0,2.076.652,9.254,10.723",
    transform: "translate(6396.71 -5044)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26708",
    "data-name": "Path 26708",
    d: "M17.192,497.564a4.162,4.162,0,1,1,0,8.31,4.162,4.162,0,1,1,0-8.31",
    transform: "translate(6396.71 -5044)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26709",
    "data-name": "Path 26709",
    d: "M44.407,497.564a4.162,4.162,0,1,1-4.4,4.155,4.282,4.282,0,0,1,4.4-4.155",
    transform: "translate(6396.71 -5044)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26710",
    "data-name": "Path 26710",
    d: "M19.65,499.455A4.6,4.6,0,1,0,21,502.71a4.6,4.6,0,0,0-1.351-3.255m-.747,5.763a3.546,3.546,0,1,1,1.04-2.508,3.546,3.546,0,0,1-1.04,2.508",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26711",
    "data-name": "Path 26711",
    d: "M44.075,498.1a4.606,4.606,0,1,0,4.606,4.606,4.606,4.606,0,0,0-4.606-4.606m0,8.154a3.548,3.548,0,1,1,3.548-3.548,3.548,3.548,0,0,1-3.548,3.548",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26712",
    "data-name": "Path 26712",
    d: "M46.16,482.068a.527.527,0,0,0-.444-.242H37.282v-5.172a.53.53,0,0,0-.528-.528H5.81a.53.53,0,0,0-.528.528V502.71a.53.53,0,0,0,.528.528h6.229v-1.056h-5.7v-2.2H10.41v-1.057H6.338V477.182H36.229v2.2H8.54v1.056H36.23v18.487H22.382v1.056H36.229v2.2H20.756v1.056H39.729v-1.055H37.282v-19.3h8.142l.085.131,1.047,1.628.284.441H40.015a.53.53,0,0,0-.528.528v7.328a.53.53,0,0,0,.528.528H52.233l.085.131.154.24.045.071v5.016H50.074v1.056h2.443v2.2H48.445v1.056h4.6a.53.53,0,0,0,.528-.528v-8.955a.515.515,0,0,0-.083-.285Zm4.87,10.343H40.543v-6.272h6.515v-.72l.527.82,3.685,5.732.284.441Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26713",
    "data-name": "Path 26713",
    d: "M39.437,493.517a.829.829,0,0,1-.14-.188.829.829,0,0,0,.14.188",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22209",
    "data-name": "Rectangle 22209",
    width: 10.843,
    height: 1.058,
    transform: "translate(6405.241 -4570.821)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26714",
    "data-name": "Path 26714",
    d: "M5.578,474.763a1.07,1.07,0,1,1,1.07-1.07,1.07,1.07,0,0,1-1.07,1.07m0-1.331a.261.261,0,1,0,.261.261.261.261,0,0,0-.261-.261",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26715",
    "data-name": "Path 26715",
    d: "M31.864,507.192a.4.4,0,0,1-.286-.119l-.913-.913a.4.4,0,0,1-.006-.566l.006-.006.913-.913a.4.4,0,0,1,.566-.006l.006.006.913.913a.4.4,0,0,1,.006.566l-.006.006-.913.913a.4.4,0,0,1-.286.119m-.341-1.318.341.341.341-.341-.341-.341Z",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26716",
    "data-name": "Path 26716",
    d: "M41.542,480.931a.4.4,0,0,1-.286-.119l-.913-.913a.4.4,0,0,1-.006-.566l.006-.006.913-.913a.4.4,0,0,1,.566-.006l.006.006.913.913a.4.4,0,0,1,.006.566l-.006.006-.913.914a.4.4,0,0,1-.286.118m-.342-1.318.341.342.341-.342-.341-.341Z",
    transform: "translate(6396.71 -5044)",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26717",
    "data-name": "Path 26717",
    d: "M2.015,502.622a.67.67,0,0,0,.671-.671v-.671h.671a.671.671,0,0,0,0-1.342H2.686v-.671a.671.671,0,1,0-1.342,0v.673H.673a.671.671,0,0,0,0,1.342h.677v.671a.671.671,0,0,0,.669.671",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransHover);
export default __webpack_public_path__ + "static/media/transHover.9d66d2fab594e18b0460479bf2b258f3.svg";
export { ForwardRef as ReactComponent };